import React from 'react'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'
import axios from 'axios'
import { servAddr } from '../../servAddr'
import { fetchSets, addSets, sortSets, searchSets } from "../../actions/settings"
import SetsSakhItem from "./SetsSakhItem"
import SettingsForm from './SettingsForm'

class SetsSakh extends SettingsForm {

  modelName = 'sakh'

  newItem = {
    sakh_team: '',
    sakh_captain: '',
    sakh_captain_bd: '',
    sakh_fisher1: '',
    sakh_fisher1_bd: '',
    sakh_fisher2: '',
    sakh_fisher2_bd: '',
    sakh_fisher3: '',
    sakh_fisher3_bd: '',
    sakh_tel: '',
    sakh_email: '',
    sakh_active: 1,
    sakh_special: 0
  };

  exportClick = () => {
    this.setState({errors: {}});
    axios({
      method: 'get',
      url: servAddr + 'excel_sakh',
      responseType: 'arraybuffer'
    }).then(response => {
      let blob = new Blob([response.data], {type: 'application/vnd.ms-excel'});
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `Список команд.xls`;
      link.click();
    }, (err) => {
      this.setState({
        errors: err.response.data.errors || {form: "Ошибка " + err.response.status}
      });
    });
  }

  render() {
    if(isEmpty(this.props.sakhs.data)){
      return(<div>Не загружены данные</div>);
    }
    const sakhs = this.props.sakhs.data;
    const { search, sort } = this.props.sakhs;
    const { data, errors } = this.state;

    var fltrSakhs = [];
    for(var key in sakhs){
      if(sakhs.hasOwnProperty(key)){
        const active = sakhs[key].sakh_active === 1;
        var found = true;
        if(search !== ''){
          const searchValue = "" + sakhs[key].sakh_team +
            sakhs[key].sakh_captain +
            sakhs[key].sakh_fisher1 +
            sakhs[key].sakh_fisher2 +
            sakhs[key].sakh_fisher3 +
            sakhs[key].sakh_email;
          found = searchValue.toLowerCase().indexOf(search) !== -1;
        }
        if(active && found){
          fltrSakhs.push(sakhs[key]);
        }
      }
    }

    const srtSakhs = fltrSakhs.sort( (a, b) => {
      if(a[sort.field] < b[sort.field])
         return sort.asc ? -1 : 1
      if(a[sort.field] > b[sort.field])
         return sort.asc ? 1 : -1
      if(a.sakh_id < b.sakh_id)
         return sort.asc ? -1 : 1
      if(a.sakh_id > b.sakh_id)
         return sort.asc ? 1 : -1
      return 0
    });

    const mappedSakhs = srtSakhs ? srtSakhs.map(sakh =>
      <SetsSakhItem key={sakh.sakh_id}
        data={sakh}
      />
    ) : [];

    const addNew = this.state.adding ?
      <tr>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.sakh_team}
              name="sakh_team"
              onChange={this.updateInput}
              placeholder="Команда"
              autoFocus
            />
          </div>
          <div className="form-inline">
            <button  type="button" className="btn btn-success"
              onClick={this.saveItem} title="Сохранить">
              <span className="glyphicon glyphicon-save"></span>
            </button>{" "}
            <button type="button" className="btn btn-default"
              onClick={this.cancelAdding} title="Отменить">
              <span className="glyphicon glyphicon-remove"></span>
            </button>{" "}Соц.{" "}
            <input
              type="checkbox"
              className="form-control"
              checked={data.sakh_special}
              name="sakh_special"
              onChange={this.handleChBox}
              title="Соц. защита"
            />
          </div>
        </td>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.sakh_email}
              name="sakh_email"
              onChange={this.updateInput}
              placeholder="Email"
            />
          </div>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.sakh_tel}
              name="sakh_tel"
              onChange={this.updateInput}
              placeholder="Телефон"
            />
          </div>
        </td>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.sakh_captain}
              name="sakh_captain"
              onChange={this.updateInput}
              placeholder="Капитан"
            />
          </div>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.sakh_captain_bd}
              name="sakh_captain_bd"
              onChange={this.updateInput}
              placeholder="Д.р. капитана"
            />
          </div>
        </td>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.sakh_fisher1}
              name="sakh_fisher1"
              onChange={this.updateInput}
              placeholder="Ловец 2"
            />
          </div>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.sakh_fisher1_bd}
              name="sakh_fisher1_bd"
              onChange={this.updateInput}
              placeholder="Д.р. ловца 2"
            />
          </div>
        </td>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.sakh_fisher2}
              name="sakh_fisher2"
              onChange={this.updateInput}
              placeholder="Ловец 3"
            />
          </div>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.sakh_fisher2_bd}
              name="sakh_fisher2_bd"
              onChange={this.updateInput}
              placeholder="Д.р. ловца 3"
            />
          </div>
        </td>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.sakh_fisher3}
              name="sakh_fisher3"
              onChange={this.updateInput}
              placeholder="Ловец 4"
            />
          </div>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.sakh_fisher3_bd}
              name="sakh_fisher3_bd"
              onChange={this.updateInput}
              placeholder="Д.р. ловца 4"
            />
          </div>
        </td>
      </tr>
      :[];


    return (
      <div>
        <h3 className="pull-right">Участники Сахалинского льда</h3>
        <div className="form-group form-inline">
          <button
            className="btn btn-primary"
            onClick={this.startAdding}
          >
            Создать
          </button>{" "}
          <button className="btn btn-default"
            onClick={this.exportClick}>
            Экспорт в Excel
          </button>{" "}
          <div className="input-group">
            <input
              type="search"
              className="form-control"
              value={search}
              title="Поиск"
              placeholder="Поиск"
              onChange={this.handleSearch} />
            <div className="input-group-btn">
              <button
                type="button"
                className="btn btn-default"
                onClick={this.clearSearch}
                title="Очистить поиск">
                X
              </button>
            </div>
          </div>{" "}
          <div className="input-group">{fltrSakhs.length} записей</div>
        </div>
        {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        <table className="table table-striped table-hover sticky-50">
          <thead>
            <tr style={{cursor:'pointer'}}>
              <th className="col-md-2" onClick={() => {this.handleSort('sakh_team')}}>Команда</th>
              <th className="col-md-2" onClick={() => {this.handleSort('sakh_email')}}>Контакты</th>
              <th className="col-md-2" onClick={() => {this.handleSort('sakh_captain')}}>Капитан</th>
              <th className="col-md-2" onClick={() => {this.handleSort('sakh_fisher1')}}>Ловец 2</th>
              <th className="col-md-2" onClick={() => {this.handleSort('sakh_fisher2')}}>Ловец 3</th>
              <th className="col-md-2" onClick={() => {this.handleSort('sakh_fisher3')}}>Ловец 4</th>
            </tr>
          </thead>
          <tbody>
            {addNew}
            {mappedSakhs}
            <tr onClick={this.startAdding}>
              <td colSpan="6"><u>Нажмите, чтобы добавить запись</u></td>
            </tr>
          </tbody>
        </table>
      </div>
    )

  }
}

function mapOrdersToProps(store) {
  return {
    sakhs: store.sakhs
  }
}

export default connect(mapOrdersToProps, { fetchSets, addSets, sortSets, searchSets })(SetsSakh);



// WEBPACK FOOTER //
// ./src/components/settings/SetsSakh.js